/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "climate-earthquake-357a9ab2--sprite",
  "use": "climate-earthquake-357a9ab2--sprite-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"climate-earthquake-357a9ab2--sprite\"><rect width=\"36\" height=\"36\" fill=\"none\" /><g transform=\"translate(-939.204 -463.477)\"><g transform=\"translate(941.204 469.477)\"><g transform=\"translate(16.016 1.183)\"><path d=\"M45.9,14.012l1.792.893L45,20.261l2.688,1.785-1.183,3.571H60.229V7.763H47.15Zm8.063-2.678h3.583V14.9H53.958Zm0,7.141h3.583v3.571H53.958Zm-5.375-7.141h3.583V14.9H48.583Zm0,7.141h3.583v3.571H48.583ZM47.688,3.3l-.717,3.571H61.125L57.542,3.3Z\" transform=\"translate(-45 -3.3)\" fill=\"currentColor\" /></g><path d=\"M16.806,12.5l-1.863-.75L15.8,4.5.968,5.714,2.4,23.5,17.093,22.32l.287-2.714-2.831-1.571ZM3.942,9.035,7.525,8.75l.287,3.571-3.583.286ZM4.8,19.713l-.287-3.571L8.1,15.856l.287,3.571ZM9.281,8.607l3.583-.286.287,3.571-3.583.286Zm.86,10.678-.287-3.571,3.583-.286L13.724,19ZM16.3,0,3.3,1.036,0,4.893,15.91,3.607Z\" fill=\"currentColor\" /></g></g></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
